import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';
import StopSubscription from './StopSubscription';
import { NotificationContext } from '../../components/GrowlNotifications';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';

const SUBSCRIPTION_INFORMATION_QUERY = gql`
  query subscriptionInformationQuery($accountId: ID!) {
    account(id: $accountId) {
      id
      displayName
      subscriptionInformation {
        currentSubscription {
          endsOn
        }
      }
    }
  }
`;

const DEFAULT_ACCOUNT_STATE = {
  id: null,
  displayName: null,
  subscriptionInformation: {
    currentSubscription: {
      endsOn: null,
    },
  },
};

const StopOwnSubscription = () => {
  const [account, setAccount] = useState(DEFAULT_ACCOUNT_STATE);

  const { aid: accountId } = useParams();
  const growl = useContext(NotificationContext);

  const { loading, error, data } = useQuery(SUBSCRIPTION_INFORMATION_QUERY, {
    variables: {
      accountId,
    },
    fetchPolicy: 'no-cache',
  });

  const { account: requestAccount } = data;

  useEffect(() => {
    if (requestAccount) {
      setAccount(requestAccount);
    }
  }, [requestAccount]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  return <StopSubscription managingAccountId={accountId} clientAccount={account} />;
};

export default StopOwnSubscription;
